import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { signInWithEmailAndPassword, signOut } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db, isFirebaseConfigured } from '../../firebase/config';
import './Auth.css';
import { appConfig } from '../../config/appConfig';
import { demoCredentials, isDemoConfigured, DEMO_SESSION_KEY } from '../../config/demoConfig';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!isFirebaseConfigured) {
      if (isDemoConfigured && email === demoCredentials.email && password === demoCredentials.password) {
        sessionStorage.setItem(DEMO_SESSION_KEY, 'active');
        navigate('/demo');
        return;
      }

      setError(isDemoConfigured
        ? 'Credenciales incorrectas para el acceso local de demostración.'
        : 'Configura Firebase o las credenciales opcionales del modo demostración.');
      return;
    }
    
    if (!email || !password) {
      setError('Por favor ingresa tu email y contraseña');
      return;
    }
    
    try {
      setError('');
      setLoading(true);
      const credential = await signInWithEmailAndPassword(auth, email, password);
      const [accessProfile, clientProfile] = await Promise.all([
        getDoc(doc(db, 'levapan_users', credential.user.uid)),
        getDoc(doc(db, 'levapan_usuarios', credential.user.uid))
      ]);

      if (!accessProfile.exists() && !clientProfile.exists()) {
        await signOut(auth);
        setError('Esta cuenta existe en Firebase, pero no tiene acceso habilitado para Levapán.');
        return;
      }

      navigate('/dashboard');
    } catch (error) {
      console.error('Error al iniciar sesión:', error);
      switch (error.code) {
        case 'auth/invalid-email':
          setError('El email ingresado no es válido');
          break;
        case 'auth/user-disabled':
          setError('Esta cuenta ha sido deshabilitada');
          break;
        case 'auth/user-not-found':
          setError('No existe una cuenta con este email');
          break;
        case 'auth/wrong-password':
          setError('La contraseña ingresada es incorrecta');
          break;
        default:
          setError('Ocurrió un error al iniciar sesión. Intenta nuevamente.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <span className="auth-brand">LEVAPÁN</span>
          <h1>
            <i className="fas fa-taxi"></i> {appConfig.appName}
          </h1>
          <h2>Bienvenido</h2>
          <p>Ingresa para gestionar clientes, reservas y reportes.</p>
        </div>

        {!isFirebaseConfigured && isDemoConfigured && (
          <div className="auth-setup-notice">
            <i className="fas fa-shield-alt"></i>
            <span>Acceso local de demostración activo. No contiene datos reales.</span>
          </div>
        )}
        
        {error && (
          <div className="auth-error">
            <i className="fas fa-exclamation-circle"></i>
            <span>{error}</span>
          </div>
        )}
        
        <form className="auth-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <div className="input-with-icon">
              <i className="fas fa-envelope"></i>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Ingresa tu email"
                required
              />
            </div>
          </div>
          
          <div className="form-group">
            <label htmlFor="password">Contraseña</label>
            <div className="input-with-icon">
              <i className="fas fa-lock"></i>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Ingresa tu contraseña"
                required
              />
            </div>
          </div>
          
          <button
            type="submit"
            className="auth-button"
            disabled={loading}
          >
            {loading ? (
              <>
                <i className="fas fa-spinner fa-spin"></i> Iniciando sesión...
              </>
            ) : (
              'Iniciar Sesión'
            )}
          </button>
        </form>
        
        <div className="auth-footer">
          {isFirebaseConfigured ? (
            <p>¿No tienes una cuenta? <Link to="/signup">Regístrate</Link></p>
          ) : (
            <p>Las cuentas serán independientes de Big Security.</p>
          )}
        </div>
      </div>
    </div>
  );
}

export default Login;
